import { getAuthAxiosBackend } from "../helpers/axios"

class OldIdentificationCardServices{

    get(id){
        return getAuthAxiosBackend().get('OldIdentificationCards/getOldIdentificationCards/' + id.toString())
    }

    getByPersonId(personId){
        return getAuthAxiosBackend().get('OldIdentificationCards/getOldIdentificationCardsByPersonId/' + personId)
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('OldIdentificationCards/all', {params: data})
    }

    add(data){
        return getAuthAxiosBackend().post('OldIdentificationCards/addOldIdentificationCards', data)
    }

    edit(id, data){
        return getAuthAxiosBackend().put('OldIdentificationCards/updateOldIdentificationCards/' + id, data)
    }

    delete(id){
        return getAuthAxiosBackend().delete('OldIdentificationCards/softDeleteOldIdentificationCards/' + id.toString())
    }
}

export default new OldIdentificationCardServices()